module.exports = __webpack_public_path__ + "img/ot.d2b89e88.jpg";